module.exports = __webpack_public_path__ + "assets/img/title-aa23d889.png";